import { render, staticRenderFns } from "./Special.vue?vue&type=template&id=7524469b&scoped=true"
import script from "./Special.vue?vue&type=script&lang=js"
export * from "./Special.vue?vue&type=script&lang=js"
import style0 from "./Special.vue?vue&type=style&index=0&id=7524469b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7524469b",
  null
  
)

export default component.exports